export default __webpack_public_path__ + "static/media/photo-1554384645-13eab165c24b.f45d7937.jpeg";